import { createSlice } from "@reduxjs/toolkit";
import { InstanceApi } from "../../helpers/InstanceApi";
import { setPopup } from "../popupSlice";

export const prodTaskHistorySlice = createSlice({
  name: "prodTaskHistory",
  initialState: {
    dataByTask: undefined,
  },
  reducers: {
    setDataByTask: (state, action) => {
      state.dataByTask = action.payload;
    },
  },
});

export const getDataByTask = (params) => async (dispatch) => {
  try {
    dispatch(setDataByTask(undefined));
    const response = await InstanceApi.get(
      "/prod/tasks/" + params.taskId + "/history"
    );
    if (response) {
      dispatch(setDataByTask(response.data.data));
    }
  } catch (error) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: error.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
    console.error(error);
  }
};

export const { setDataByTask } = prodTaskHistorySlice.actions;
export default prodTaskHistorySlice.reducer;
